import { Component, Input, OnInit } from '@angular/core';

import { Image } from '@common/core/models';
import { VehicleGalleryDialogComponent } from '../vehicle-gallery-dialog/vehicle-gallery-dialog.component';
import { DialogsService } from '@web/core/services';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'cci-vehicle-gallery',
  templateUrl: './vehicle-gallery.component.html',
  styleUrls: ['./vehicle-gallery.component.scss'],
})
export class VehicleGalleryComponent implements OnInit {
  @Input() galleryTitle: string;
  @Input() gallery: Image[];
  @Input() size: 'small' | 'medium' | 'large' | 'zoom' = 'small';
  @Input() showGallery = false;
  @Input() youtubeEmbedUrl: string;
  @Input() showZoom = false;

  imageIndex = 0;
  youtubeUrl: SafeResourceUrl;
  mediaGallery: { videoUrl?: SafeResourceUrl; type: 'image' | 'video'; image?: Image }[] = [];
  nextImage: Image;

  constructor(private dialogsService: DialogsService, private domSanitizer: DomSanitizer) {}

  ngOnInit(): void {
    if (this.gallery?.length) {
      this.mediaGallery = this.gallery.map(image => ({ image, type: 'image' }));
    }

    try {
      if (this.youtubeEmbedUrl) {
        this.youtubeUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(this.youtubeEmbedUrl);
        if (this.mediaGallery.length) {
          this.mediaGallery.splice(1, 0, { videoUrl: this.youtubeUrl, type: 'video' });
        } else {
          this.mediaGallery.push({ videoUrl: this.youtubeUrl, type: 'video' });
        }
      }
    } catch (e) {}

    // setTimeout(() => {
    //   this.preloadNextImage();
    // }, 3000);
  }

  showPreviousImage(event) {
    event.stopPropagation();
    if (this.imageIndex === 0) {
      this.imageIndex = this.mediaGallery.length - 1;
    } else {
      this.imageIndex--;
    }
  }

  showNextImage(event) {
    event.stopPropagation();
    if (this.imageIndex === this.mediaGallery.length - 1) {
      this.imageIndex = 0;
    } else {
      this.imageIndex++;
    }
  }

  onZoom() {
    this.dialogsService.dialog.open(VehicleGalleryDialogComponent, {
      width: '98%',
      // minWidth: '600px',
      maxWidth: '1600px',
      // height: '90%',
      maxHeight: '90vh',
      data: {
        gallery: this.gallery,
        youtubeEmbedUrl: this.youtubeEmbedUrl,
      },
    });
  }

  onImageLoaded() {
    this.preloadNextImage();
  }

  private preloadNextImage() {
    const trimmedMediaGallery = [...this.mediaGallery].slice(this.imageIndex + 1);
    const nextImage = trimmedMediaGallery.find(mediaItem => mediaItem?.type === 'image');
    if (nextImage?.type === 'image') {
      this.nextImage = nextImage.image;
    }
  }
}
